import React from "react";
import { connect } from "react-redux";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import ImageContainer from "@components/imageContainer";
import { getWidgetSpecificProps } from "@utils/index";
import { resolvePath } from "@utils/resolvePath";
import { TextDescWrapper, DescriptionText, ImageBoxContainer } from "./styles";
import { CommonProps } from "@utils/interface";

const mapStateToProps = (state: any, ownProps: any) => {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

interface ImageWithTextDescProps extends CommonProps {
  src: string;
  alt?: string;
  text: string;
  styles?: object;
  imgStyles?: object;
  textStyles?: object;
  height?: number;
  width?: number;
  isResolvePath?: boolean;
}
const ImageWithTextDesc = (props: ImageWithTextDescProps) => {
  const {
    src,
    alt,
    text,
    is_visible,
    styles,
    imgStyles,
    textStyles,
    height = 64,
    width = 64,
    isResolvePath = false
  } = props;

  if (!is_visible) return null;

  return (
    <TextDescWrapper styles={styles}>
      <Flex alignItems="center">
        <ImageBoxContainer style={imgStyles}>
          <img
            src={isResolvePath ? resolvePath(src) : src}
            alt={alt}
            height={height}
            width={width}
          />
        </ImageBoxContainer>
        <DescriptionText styles={textStyles}>{text}</DescriptionText>
      </Flex>
    </TextDescWrapper>
  );
};

export default connect(mapStateToProps)(ImageWithTextDesc);
